<template>
  <div>
    <back-button default-to="/repairs" />
    <b-card no-header>
      <ValidationObserver ref="form">
        <form @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12" md="4">
              <form-group-input ref="tanggal_perbaikan" type="date" label="Tanggal perbaikan" :need-label="true" v-model="repairModel.tanggal_perbaikan.value" :rules="repairModel.tanggal_perbaikan.rules" id="tanggal_perbaikan" />
            </b-col>
            <b-col cols="12" md="8">
              <form-group-input type="text" label="Nama barang" :need-label="true" v-model="repairModel.nama_barang.value" :rules="repairModel.nama_barang.rules" id="nama_barang" />
            </b-col>
            <b-col cols="12" md="6">
              <form-group-input type="text" label="Kadar" :need-label="true" v-model="repairModel.kadar.value" :rules="repairModel.kadar.rules" id="kadar" />
            </b-col>
            <b-col cols="12" md="3">
              <form-group-input type="number" label="Berat (gram)" :need-label="true" min="0.001" step="0.001" v-model="repairModel.berat.value" :rules="repairModel.berat.rules" id="berat" />
            </b-col>
            <b-col cols="12" md="3">
              <form-group-input type="price" label="Biaya perbaikan" :need-label="true" v-model="repairModel.biaya_perbaikan.value" :rules="repairModel.biaya_perbaikan.rules" id="biaya_perbaikan" />
            </b-col>
            <b-col cols="12">
              <form-group-input type="textarea" label="Deskripsi kerusakan" :need-label="true" rows="4" v-model="repairModel.deskripsi_kerusakan.value" :rules="repairModel.deskripsi_kerusakan.rules" id="deskripsi_kerusakan" />
            </b-col>
          </b-row>
          <div class="mt-3">
            <b-button type="submit" variant="primary" :disabled="isLoading"><font-awesome-icon v-if="isLoading" icon="spinner" spin /> Simpan</b-button>
            <b-button to="/repairs" variant="secondary" class="ml-2">Batal</b-button>
          </div>
        </form>
      </ValidationObserver>
    </b-card>
  </div>
</template>

<script>
import { saveProcess, setModelValue, scrollToError } from '@/_helpers'
import FormGroupInput from '@/components/FormGroupInput.vue'
import Repair from '@/models/Repair.js'

const repairModel = new Repair()

export default {
  components: { FormGroupInput },
  data () {
    return { isLoading: false, repairModel: repairModel.init() }
  },
  computed: {
    mode () { return this.$route.params.id ? 'update' : 'create' }
  },
  mounted () {
    if (this.mode === 'update') this.getDetail()
    else this.setDate(this.$moment().format('YYYY-MM-DD'))
  },
  methods: {
    setDate (value) {
      this.repairModel.tanggal_perbaikan.value = value
      if (this.$refs.tanggal_perbaikan) this.$refs.tanggal_perbaikan.setValue(value)
    },
    async getDetail () {
      this.isLoading = true
      try {
        const response = await repairModel.find(this.$route.params.id)
        setModelValue(this.repairModel, response, true)
        this.setDate(this.repairModel.tanggal_perbaikan.value)
      } catch (error) {
        this.$store.dispatch('notification/error', error)
      }
      this.isLoading = false
    },
    onSubmit () {
      this.$refs.form.validate().then(valid => {
        if (!valid || this.isLoading) {
          if (!valid) scrollToError(this.$refs.form)
          return
        }
        saveProcess(this.repairModel, this.mode === 'update').then(payload => {
          this.isLoading = true
          const request = this.mode === 'update' ? repairModel.update(this.$route.params.id, payload) : repairModel.create(payload)
          request.then(() => {
            this.$store.dispatch('notification/success', this.mode === 'update' ? 'Data perbaikan berhasil diubah.' : 'Data perbaikan berhasil disimpan.')
            this.$router.push('/repairs')
          }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
        }).catch(() => {})
      })
    }
  }
}
</script>
